import { ActionContext } from 'vuex';

import { ActionClass, ContextState, Dictionary, Filter, FilterSelectedValues } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class SetFiltersSelectedValuesAction implements ActionClass {

  public static execute({ state, commit }: ActionContext<ContextState, any>, selectedValues: Dictionary<FilterSelectedValues>): void {
    const filters = {};
    Object.values(state.filters).forEach((filter: Filter) => {
      if (filter.config.id in selectedValues) {
        filter = {
          config: filter.config,
          selectedValues: selectedValues[filter.config.id]
        };
      }
      filters[filter.config.id] = filter;
    });
    commit(CONTEXT_CONSTS.mutations.setContext, {
      filters: filters
    });
  }

}
